/**
 * 客服聊天 Store
 * @description 存储客服信息、会话状态和弹框控制
 */
import { defineStore } from 'pinia'

export interface CustomerServiceInfo {
  id: number
  uid: number
  nickName: string
  avatar: string
  postTitleName: string
  workTime: string
  phone: string
  wechat: string
  welcomeMessage: string
  skillList: any[]
  isOnline: boolean
}

export interface ConversationInfo {
  id: number
  customerId: number
  customerServiceId: number
  channelId?: number
  status: number
  createTime: string
  updateTime: string
  userUnReadMessageCount?: number
}

interface CustomerServiceState {
  customerServiceInfo: CustomerServiceInfo | null
  conversationInfo: ConversationInfo | null
  isPopupVisible: boolean // 控制弹框显示
  exhibitionId: string | number | null // 当前展会ID
  isServiceOnline: boolean
}

export const useCustomerServiceStore = defineStore('customerService', {
  state: (): CustomerServiceState => ({
    customerServiceInfo: null,
    conversationInfo: null,
    isPopupVisible: false,
    exhibitionId: null,
    isServiceOnline:false
  }),

  getters: {
    // 获取客服ID
    serviceId: (state): number => {
      return state.customerServiceInfo?.id || 0
    },
    
    // 获取客服UID
    serviceUid: (state): number => {
      return state.customerServiceInfo?.uid || 0
    },

    // 是否有活跃会话
    hasActiveConversation: (state): boolean => {
      return !!state.conversationInfo && state.conversationInfo.status === 1
    },

    // 弹框是否显示
    isVisible: (state): boolean => {
      return state.isPopupVisible
    },
  },

  actions: {
    // 设置客服信息
    setCustomerServiceInfo(data: CustomerServiceInfo | null) {
      this.customerServiceInfo = data
    },

    // 设置会话信息
    setConversationInfo(data: ConversationInfo | null) {
      this.conversationInfo = data
    },

    // 打开客服弹框
    openPopup(exhibitionId?: string | number) {
      if (exhibitionId) {
        this.exhibitionId = exhibitionId
      }
      this.isPopupVisible = true
      this.isServiceOnline = true
      localStorage.setItem('isServiceFloat', 'true')
    },

    // 关闭客服弹框
    closePopup() {
      this.isPopupVisible = false
    },

    // 切换弹框显示状态
    togglePopup() {
      this.isPopupVisible = !this.isPopupVisible
    },

    // 清除客服浮框状态
    clearServiceFloat() {
      this.isServiceOnline = false
      localStorage.removeItem('isServiceFloat')
    },

    // 从 localStorage 初始化浮框状态
    initServiceFloatFromStorage() {
      const isServiceFloat = localStorage.getItem('isServiceFloat')
      if (isServiceFloat === 'true') {
        this.isServiceOnline = true
      }
    },

    // 重置所有状态
    reset() {
      this.customerServiceInfo = null
      this.conversationInfo = null
      this.isPopupVisible = false
      this.exhibitionId = null
    },
  },
})
